import { Component, ElementRef, Inject, OnInit, HostListener, AfterViewChecked } from '@angular/core';
import { DefaultValuesService } from '../../services/defaultvalues.service';
import { ComponentTool } from '../../interfaces/componenttool'

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less', '../../style/new-generic-styles.component.less'],
    standalone: false
})
export class HomeComponent implements OnInit, AfterViewChecked {
    version: string | undefined = '0.0.0.0';

    //showBanner: boolean = false;

    rulebookUrl: string = '';
    componentToolEnum: typeof ComponentTool = ComponentTool;
    components: any[]
    elementRef: ElementRef | null | undefined
    
    numberOfColumns: number = 3;

    constructor(
        public defaults: DefaultValuesService,
        @Inject('BASE_URL') private readonly baseUrl: string) {
        this.components = []
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.updateGridCols();
    }
    
    updateGridCols() {
        const width = window.innerWidth;
        if (width >= 1920) {
            this.numberOfColumns = 4;
        } else if (width >= 1366) { // was 1366 as a thought, let's stick to user request "standard" vs "small"
            this.numberOfColumns = 3;
        } else {
            this.numberOfColumns = 2;
        }
    }

    ngOnInit() {
        this.updateGridCols();
    }

    get items(): any[] {
        if (this.defaults.componentTool === this.componentToolEnum.Mersy) {
            return this.defaults.menuClusters || [];
        }
        return this.defaults.components || [];
    }

    getRoute(item: any): string {
        return item.Route ? '/' + item.Route : '';
    }

    getDisplayTitle(item: any): string {
        if (this.defaults.componentTool === this.componentToolEnum.Rulebook) {
            return this.toTitleCase(`${item.ClusterName || ''}${item.ClusterName ? ' - ' : ''}${item.DisplayName}`);
        }
        return this.toTitleCase(item.DisplayName);
    }

    private toTitleCase(text: string): string {
        if (!text) return text;
        return text.split(' ').map(word => {
            if (word === word.toUpperCase()) return word;
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    }

    onItemClick(item: any) {
        this.setSelectedItem(item.ClusterId)
    }

    ngAfterViewChecked() {
        if (this.items.length > (this.numberOfColumns * 3)) {
            const element = document.getElementById("landingpage-columns");
            if (element)
                this.elementRef = new ElementRef<HTMLElement>(element)
        }
    }

    @HostListener('wheel', ['$event'])
    onWheel(event: any) {
        if (event.type === 'wheel' && this.defaults.componentTool !== this.componentToolEnum.Mersy) {
            event.preventDefault();
            if (this.elementRef) {
                this.elementRef.nativeElement.scrollLeft = this.elementRef.nativeElement.scrollLeft + event.deltaY
            }
        }
    }

    setSelectedItem(selectedItemNumb: number | undefined) {
        this.defaults.selectedItem = -1;
        this.defaults.selectedItem = selectedItemNumb ?? -1;
        localStorage.setItem('currentSelectedItem', this.defaults.selectedItem.toString());
    }

    getComponentClass(index: number, clusterId: number) {
        if (this.defaults.componentTool === this.componentToolEnum.Rulebook) {
            if (clusterId % 3 === 0) return 'tke-orange'
            if (clusterId % 3 === 1) return 'tke-intermediate-color'
            if (clusterId % 3 === 2) return 'tke-purple'
        }
        else {
            if (index % 3 === 0) return 'tke-orange'
            if (index % 3 === 1) return 'tke-intermediate-color'
            if (index % 3 === 2) return 'tke-purple'
        }
        return '';
    }

    isExternalLink(link:any) {
        const httpRegex = /^http:\/\//i; // Match "http://" with case-insensitivity
        const httpsRegex = /^https:\/\//i; // Match "https://" with case-insensitivity
        return httpRegex.test(link) || httpsRegex.test(link);
    }
    externalRedirect(link: any) {
        window.open(link, "_blank");
    }
}
